var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"width":"600px","height":"300px","background-color":"#DAE4E4"},attrs:{"id":"myDiagramDiv"}})])}]

export { render, staticRenderFns }